<div class="container my-3">
  <!-- <h1 class="mb-3">Edit Element Manufacturer</h1> -->
  <form #form="ngForm" (ngSubmit)="updateManufacturer()" class="mt-4">
    <div class="row">
      <div class="col-sm-1" style="text-align: center">
        <label for="name" class="form-label">Name</label>
      </div>
      <div class="col-sm-4">
        <input type="text" style="float: left" class="form-control border border-dark" id="name" name="name"
          [(ngModel)]="manufacturerDetails.Name" />
        <div *ngIf="NameError" class="text-danger" style="text-align: left; color: gray">
          This field is required
        </div>
      </div>
    </div>
    <div style="min-height: 100px"></div>
    <div class="row">
      <div class="col-sm-1" style="text-align: right">
        <button type="submit" class="btn custom-buttons-btn">Update</button>
      </div>
      <div class="col-sm-1" style="text-align: left">
        <button type="button" class="btn custom-delete-btn" (click)="deleteManufacturer(manufacturerDetails.Id)">
          Delete
        </button>
      </div>
    </div>
  </form>
</div>